<script lang="ts">
    import { faEdit, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
    import { ServicesOnInvoices } from '../../modules/posApi/invoices/invoice'
    export let productMovementItem: ProductMovement = undefined
    import { createEventDispatcher, onMount } from 'svelte'
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import { ProductMovement } from '../../modules/posApi/stock/product-movements/product-movement'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    const dispatch = createEventDispatcher()

    let step = 1
    let isNew = false
    async function editEntity() {
        expiresAt = productMovementItem.expiresAt || null
        step = 2
    }

    async function newEntity() {
        isNew = true
        step = 2
        productMovementItem = new ProductMovement()
    }

    async function cancelEntity() {
        productMovementItem = undefined
        step = 1
        dispatch('cancel')
    }

    let expiresAt: Date = null

    async function confirmEntity() {
        if (!productMovementItem.service || !productMovementItem.quantity || !productMovementItem.value) {
            window.error('Informe todas as opções antes de confirmar.')
            return
        }
        if (expiresAt) {
            productMovementItem.expiresAt = expiresAt
        }
        productMovementItem.serviceId = productMovementItem.service.serviceId
        dispatch('added', productMovementItem)
        if (isNew) productMovementItem = undefined
        step = 1
        isNew = false
    }

    onMount(() => {
        if (!productMovementItem) newEntity()
    })
</script>

{#if productMovementItem !== undefined}
    {#if step === 1}
        <div class="row line liner py-1 h-mobile">
            <div class="col nowrap">{productMovementItem.service?.name}</div>
            <div class="col-md-1 text-end">{window.api.utils.utils.toReal(productMovementItem.value)}</div>
            <div class="col-md-1 text-end">{productMovementItem.quantity}</div>
            <div class="col-md-1 text-end">{window.api.utils.utils.toReal(productMovementItem.value * productMovementItem.quantity) || ' -'}</div>
            <div class="col-md-2 text-end">
                <Zbutton color="secondary" icon={faEdit} label="Editar" on:click={editEntity} />
            </div>
        </div>
        <div class="row line h-full content">
            <div class="col-6">
                <div class="label">Item</div>
                <div class="item nowrap">{productMovementItem.service?.name}</div>
            </div>

            <div class="col-3">
                <div class="label">Custo unit</div>
                <div class="item">{window.api.utils.utils.toReal(productMovementItem.value)}</div>
            </div>
            <div class="col-3">
                <div class="label">Qtde</div>
                <div class="item">{productMovementItem.quantity}</div>
            </div>
            <div class="col-3">
                <div class="label">Total</div>
                <div class="item">{window.api.utils.utils.toReal(productMovementItem.value * productMovementItem.quantity) || ' -'}</div>
            </div>

            <div class="col text-center">
                <Zbutton class="mt-3 mb-2" color="secondary" icon={faEdit} label="Editar" on:click={editEntity} />
            </div>
        </div>
    {/if}
    {#if step === 2}
        <ZContainer>
            <ZContainerCol size={6} sizeM={12}>
                <ZentitySelect fonte="servico" label="Item" params={{ type: 'product,consumable', price: true }} bind:value={productMovementItem.service} />
            </ZContainerCol>
            <ZContainerCol size={3} sizeM={6}>
                <Zinput type="number" label="Custo Unit" bind:value={productMovementItem.value} />
            </ZContainerCol>
            <ZContainerCol size={3} sizeM={6}>
                <Zinput type="number" label="Qtde" bind:value={productMovementItem.quantity} />
            </ZContainerCol>
            <ZContainerCol size={4} sizeM={12}>
                <Zinput label="Marca" bind:value={productMovementItem.brand} />
            </ZContainerCol>
            <ZContainerCol size={4} sizeM={12}>
                <Zinput label="Lote" bind:value={productMovementItem.batchNumber} />
            </ZContainerCol>
            <ZContainerCol size={4} sizeM={12}>
                <Zinput type="date" label="Vencimento" bind:value={expiresAt} />
            </ZContainerCol>
            <ZContainerCol sizeM={12} flex={true}>
                <Zbutton grow={true} color="red" class="me-2" icon={faTrashAlt} label="Excluir" on:click={cancelEntity} />
                <Zbutton grow={true} color="primary" icon={faCheck} label="Confirmar" on:click={confirmEntity} />
            </ZContainerCol>
        </ZContainer>
    {/if}
{/if}

<style>
    .content .label {
        color: #328866;
        font-weight: 300;
    }
    .content .item {
        margin-top: -3px;
        margin-bottom: 3px;
    }
</style>
